
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/planetscale",
      function () {
        return require("private-next-pages/destinations/planetscale.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/planetscale"])
      });
    }
  